import { withDevToolsStub } from '@angular-architects/ngrx-toolkit';

export const environment = {
  production: true,
  playwright: false,
  configFile: 'assets/config.json',
  providers: [],
  storeWithDevTools: withDevToolsStub,
};
